// init
const theme = document.querySelector('[data-menu-theme]').dataset.menuTheme;
const menuCanvas = document.getElementById('menuCanvas');
const pdcMenu = document.querySelector('.pdc-menu');

menuCanvas.confetti = menuCanvas?.confetti || confetti.create(menuCanvas, { resize: true });
// ------------------------------
// vars
let skew = 1;
const defaultOptionsPerTheme = {
  winter: {
    duration: 30 * 1000, // 20s
    reloadTime: 0, // 0s
    density: 100, // in percentage
  },
  fall: {
    duration: 10 * 1000, // 10s
    reloadTime: 5 * 1000, // 5s
    density: 80, // in percentage
  }
}
// ------------------------------
// global
const settings = {
  animation_duration: parseInt(10000) || null,
  animation_reload_time: parseInt(5000) || null,
  animation_density: parseInt(5) || null,
}
console.warn(settings)

const DURATION = (settings.animation_duration || defaultOptionsPerTheme?.[theme]?.duration || (5 * 1000));
const RELOAD_TIME = (settings.animation_reload_time || defaultOptionsPerTheme?.[theme]?.reloadTime || (20 * 1000));
// Calculate particle spawn interval based on density
// Higher density = more frequent particles = smaller interval
const densityPercentage = settings.animation_density || defaultOptionsPerTheme?.[theme]?.density || 50;
const PARTICLE_INTERVAL = Math.max(16, (100 - densityPercentage) * 2); // 16ms minimum (60fps), scales with density

let mainAnimationEnd, mainAnimation, mouseHover = false;
let lastParticleTime = 0;

initAnimationTime(true);
// ------------------------------
// listeners
pdcMenu.addEventListener('mouseenter', () => {
  initAnimationTime(false);
  menuCanvas?.confetti?.reset();
  mouseHover = true;
})
pdcMenu.addEventListener('mouseleave', () => {
  if (mouseHover) initAnimationTime(true);
  mouseHover = false;
})
// ------------------------------
// animation frames
function mainAnimationFrame() {
  const currentTime = Date.now();
  const timeLeft = mainAnimationEnd - currentTime;
  
  // Check if enough time has passed since last particle spawn
  if (currentTime - lastParticleTime >= PARTICLE_INTERVAL) {
    const ticks = Math.max(200, 500 * (timeLeft / DURATION));
    const origin = {
      x: Math.random(),
      // since particles fall down, skew start toward the top
      y: (Math.random() * Math.max(0.8, skew - 0.001)) - 0.2
    }

    const settingsPerTheme = {
      winter: {
        particleCount: 1,
        startVelocity: 0,
        ticks,
        origin,
        colors: ['#FFFFFF', '#FAFAFA', '#AAAAAA'],
        shapes: ['circle'],
        gravity: randomInRange(0.1, 0.3),
        scalar: randomInRange(0.1, .5),
        drift: randomInRange(-0.4, 0.4)
      },
      fall: {
        particleCount: 1,
        startVelocity: 0,
        ticks,
        origin,
        shapes: [
          confetti.shapeFromText({ text: '🍂', scalar: randomInRange(.5, 2) }),
          confetti.shapeFromText({ text: '🍁', scalar: randomInRange(.5, 2) })
        ],
        gravity: randomInRange(0.1, 0.6),
        scalar: randomInRange(.5, 2),
        drift: randomInRange(-0.5, 0.5)
      }
    }
      
    const themeSettings = settingsPerTheme?.[theme] || {};

    menuCanvas.confetti({
      ...themeSettings
    });
    
    lastParticleTime = currentTime;
  }

  if (timeLeft > 0) {
    mainAnimation = requestAnimationFrame(mainAnimationFrame);
  } else {
    setTimeout(() => {
      initAnimationTime(true);
    }, RELOAD_TIME);
  }
}
// ------------------------------
// functions
function initAnimationTime(start = false){
  if (mainAnimation) {
    cancelAnimationFrame(mainAnimation);
    menuCanvas.confetti.reset();
  }
  mainAnimationEnd = Date.now() + DURATION;
  lastParticleTime = Date.now(); // Reset particle timer
  if (start) {
    mainAnimation = requestAnimationFrame(mainAnimationFrame);
  }
}
function randomInRange(min, max) {
  return Math.random() * (max - min) + min;
}